import axios from '@/plugins/axios'

export function getRidingCardUserBags(params = {}) {
  return axios.get('card_riding_user_bags', { params })
}

export function getRidingCardUserBagCardLogs(params = {}) {
  return axios.get('card_riding_user_bags/cardLogs', { params })
}
